export enum LinkType {
	Internal = 0,
	External = 1,
}

export interface MenuOption {
	title: string;
	link: string;
	type?: LinkType;
	className?: string;
}

export const items: Array<MenuOption> = [
	{
		title: 'Exclusive Packages',
		link: '/valueinclusive',
		type: LinkType.External,
	},
	{
		title: 'Destinations',
		// eslint-disable-next-line max-len
		link: 'https://res.onlinevacationcenter.com/swift/cruise/destination/africa?siid=228902&destinationtype=All&destinationorriverid=destinationId&activetab=CruiseLineCalendar&showpromocodes=true&destinations=2',
		type: LinkType.External,
	},
	{
		title: 'Cruise Lines',
		link: 'https://res.onlinevacationcenter.com/swift/cruise/cruiseline?siid=228902&lang=1',
		type: LinkType.External,
	},
	{
		title: 'Our Distinction',
		link: '/why-ovc',
		type: LinkType.Internal,
	},
];
